import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import { CircularProgressBar } from "../CircularProgressBar";
import { Button } from "components/atoms/Button";
import { VIEW_RECOMMENDATION_WIDGET_BIG } from "utils/constants/GoogleTagGUIDs";
import "./index.scss";

interface IProps {
  styles?: string;
  data?: any;
  theme: "light" | "dark";
  handleClick?: () => void;
}

export const AIRecommendationCard = ({ styles, data, theme, handleClick }: IProps) => {
  const getPercentage = () => {
    let maxValue = 0;
    if (
      (data && Array.isArray(data) && data.length === 0) ||
      (data &&
        Array.isArray(data) &&
        data.length > 0 &&
        data[0].RecommendedContentItems &&
        Array.isArray(data[0].RecommendedContentItems) &&
        data[0].RecommendedContentItems.length === 0)
    ) {
      return { status: false, value: 0 };
    }

    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data[0].RecommendedContentItems.forEach((item: any) => {
        if (
          item.IncorrectPercentage !== null &&
          item.IncorrectPercentage > maxValue
        ) {
          maxValue = item.IncorrectPercentage;
        }
      });

    return { status: true, value: (1 - maxValue) * 100 };
  };

  const getTitle = () => {
    let maxValue = 0;
    let titleOfMaxValue = "";
    if (
      (data && Array.isArray(data) && data.length === 0) ||
      (data &&
        Array.isArray(data) &&
        data.length > 0 &&
        data[0].RecommendedContentItems &&
        Array.isArray(data[0].RecommendedContentItems) &&
        data[0].RecommendedContentItems.length === 0)
    ) {
      return "No results";
    }

    data &&
      Array.isArray(data) &&
      data[0].RecommendedContentItems.forEach((item: any) => {
        if (
          item.IncorrectPercentage !== null &&
          item.IncorrectPercentage > maxValue
        ) {
          maxValue = item.IncorrectPercentage;
          titleOfMaxValue = item.AssessmentObjective.Parent.Name;
        }
      });

    return titleOfMaxValue;
  };

  return (
    <div
      className={classNames("ai-recommendation-container", {
        [`${styles}`]: styles,
      })}
      onClick={handleClick}
    >
      <div className="card-header">
        <Typography variant="h6Bold" label="AI Study Recommendations" />
        <div className="beta-text-container">
          <Typography variant="h7Bold" label="BETA" styles="beta-text-styles" />
        </div>
      </div>
      <div className="ai-content">
        {" "}
        <div className="ai-percentage">
          <CircularProgressBar
            inComplete={0}
            upComing={0}
            isThreeLayer={true}
            isAi={true}
            complete={0}
            theme={theme}
            aiPercentage={Math.trunc(getPercentage().value)}
            isAiNoResult={!getPercentage().status}
            // customCircularStyle={true}
          />
        </div>
        <div className="ai-title">
          <Typography
            label={getTitle()}
            variant="h5Bold"
            styles="custom-typography-style"
          />
        </div>
      </div>

      <div className="btn-section">
        <Button
          label="View Recommendations"
          type="score"
          icon={false}
          styles="ai-recommendation-card-btn"
          onClick={handleClick}
          dataTrackingId={VIEW_RECOMMENDATION_WIDGET_BIG}
        />
      </div>
    </div>
  );
};
